export default __webpack_public_path__ + "static/Coral_MiniBio-bb9605423142d03031a596ee1cfbda24.webp";